import { getBrand } from "@eforms/forms-common-ui";

export const getBrandDetails = () => {
  let cssClass;
  let label;
  let brand = getBrand();
  console.log("BRAND_IS ", brand);

  // As a part of EFORMS-3545, since Web-SDK has not published Champion them for lombard brand yet,
  // so we are adding custom logo for now and later on, once web-sdk releases theme for lombard brand, we will
  // discard this and consume the classes directly from Web-SDK

  switch (brand) {
    case "nwb":
    case "natwest":
      cssClass = "zb-brand-logo-natwest";
      label = "Natwest Logo";
      break;
    case "nwg":
      cssClass = "zb-brand-logo-natwestGroup";
      label = "Natwest Group Logo";
      break;
    case "rbs":
      cssClass = "zb-brand-logo-rb";
      label = "Royal Bank Of Scotland Logo";
      break;
    case "ubn":
    case "ulsterbank":
      cssClass = "zb-brand-logo-ulsterbank";
      label = "Ulster Bank Logo";
      break;
    case "lombard":
      cssClass = "zb-brand-logo-lombard";
      label = "Lombard Logo";
      break;
    default:
      cssClass = "zb-masthead-brand-logo";
      label = "Natwest Group Logo";
      break;
  }
  return { cssClass, label };
};
